// Statics.
import './scripts/StylesImports';
import './scripts/ImagesImports';

// Application Scripts.
import { toiConfig } from '../Settings/global.json';
import * as app from './scripts/Core/App';
import * as ToiProviderBuilder from './scripts/Core/Toi/ToiProvider';
import LNComscore from './scripts/Modules/LNComscore';
import * as Header from './scripts/Header';
import * as DfpConfigProvider from './scripts/Modules/Dfp/DfpConfigProvider';
import Dfp from './scripts/Modules/Dfp/Dfp';
import RankingMasLeidas from './scripts/Modules/RankingMasLeidas';
import TePuedeInteresar from './scripts/Modules/TePuedeInteresar';
import Newsletter from './scripts/Modules/Newsletter';
import ShareSocial from './scripts/Modules/Sharing';
import ListaHoroscopo from './scripts/Modules/ListaHoroscopo';
import ListaOtrosSignos from './scripts/Modules/ListaOtrosSignos';
import Hotjar from './scripts/Modules/Hotjar'; 
import EstoyEnApp from './scripts/Modules/estoyEnApp';

// Application Start.
app.start().then(() => {
    const providerFactory = ToiProviderBuilder.Initialize(toiConfig);

    // Comscore.
    _initializeComscore();

    // Header.
    _initializeHeader();

    // Dfp.
    _initializeDfp();

    // Ranking Más Leídas.
    _initializeRankingMasLeidas();

    // Te Puede Interesar.
    _initializeTePuedeInteresar(providerFactory);

    // Newsletter.
    _initializeNewsletter();

    // Sharing social
    _initializeSharing();

    //ListaHoroscopo
    _initializeListaHoroscopo();

    //Otros signos en Item
    _initializeListaOtrosSignos();

    // Hotjar.
    $(document).ready(function () {
        _initializeHotjar();
    });

    // EstoyEnApp.
    $(document).ready(function () {
        _initializeEstoyEnApp();
    });

});

// Private.

function _initializeComscore() {
    LNComscore.TriggerPageView();
}

function _initializeHeader() {
    Header.Initialize();
}

function _initializeDfp() {
    const moduleConfig = DfpConfigProvider.GetConfig();
    const $module = new Dfp(moduleConfig);

    $module.Load();
}

function _initializeRankingMasLeidas() {
    const $module = new RankingMasLeidas({
        max: 3
    });

    $module.Load();
}

function _initializeTePuedeInteresar(providerFactory) {
    const provider = providerFactory.getToiProvider('liftigniter');
    const $module = new TePuedeInteresar(provider, {
        max: 6
    });

    $module.Load();

}

function _initializeNewsletter() {
    Newsletter.Initialize();
}


function _initializeSharing() {
    ShareSocial.Initialize();
}

function _initializeListaHoroscopo() {
    ListaHoroscopo.Initialize();
}
function _initializeListaOtrosSignos() {
    ListaOtrosSignos.Initialize();
}

function _initializeHotjar() {
    const $module = new Hotjar({
        hotjarId: window.config.Statics.hotjarId,
        sv: window.config.Statics.hotjarSV
    });

    $module.Load();
} 

function _initializeEstoyEnApp() {
    EstoyEnApp.Initialize();
}


// WEBPACK FOOTER //
// ./Statics/site.js